<template>
  <div class="user-index">
    <div
      v-if="role && role.app"
      class="info"
    >
      <span>App:</span>
      <span>{{ role.app.name }}</span>
    </div>
    <div
      v-if="role && role.name"
      class="info"
    >
      <span>Role:</span>
      <span>{{ role.name }}</span>
    </div>
    <div class="info">
      <span>Users</span>
    </div>
    <div class="info">
      <btn
        name="Add user"
        @click="addUser"
      />
    </div>
    <list
      :columns="columns"
      :items="users"
      :buttons="[{name: 'Delete', callback: 'removeGrant'}]"
      @removeGrant="removeGrant"
    />
    <form-dialog
      v-if="userDialog"
      :header="`Add user to app ${role.app.name} and grant role ${role.name}`"
      :disabled="disabled"
      @cancel="userDialog = false"
      @save="save"
    >
      <div class="select">
        <multiselect
          v-model="user"
          :options="everyUser"
          track-by="email"
          label="email"
          placeholder="Select user"
        />
      </div>
    </form-dialog>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'UsersIndex',
    components: {
      list: () => import('@/views/admin/components/list.vue'),
      btn: () => import('@/views/admin/components/btn.vue'),
      'form-dialog': () => import('@/views/admin/components/form-dialog.vue'),
      Multiselect,
    },
    props: {},
    data() {
      return {
        role: null,
        error: false,
        userDialog: false,
        everyUser: [],
        user: null,
        columns: [
          {
            name: 'User ID',
            key: 'id',
          },
          {
            name: 'Name',
            key: 'name',
          },
          {
            name: 'Email',
            key: 'email',
          },
          {
            name: 'Grant ID',
            key: 'grantId',
          },
        ],
      };
    },
    apollo: {
      role: {
        query: gql`query ($id: String!) {
        role (id: $id) {
          id
          name
          app {
            id
            name
          }
          grants {
            id
            user {
              id
              name
              email
            }
          }
        }
      }`,
        variables() {
          return {
            id: this.$route.params.roleId,
          };
        },
        skip() {
          return !this.$route.params.roleId;
        },
        update(data) {
          return data.role;
        },
      },
    },
    computed: {
      users() {
        if (this.role) {
          return this.role.grants.map((grant) => (
            { ...grant.user, grantId: grant.id })).flat(Infinity);
        }
        return [];
      },
      disabled() {
        return !this.user;
      },
    },
    watch: {},
    mounted() {},
    methods: {
      removeGrant(item) {
        this.$apollo.mutate({
          mutation: gql`mutation($id: String!) {
            deleteOneGrant(where: { id: $id }) {
              id
            }
          }
          `,
          variables: {
            id: item.grantId,
          },
        }).then(() => {
          this.$apollo.queries.role.refetch();
        }).catch((error) => {
          this.error = error;
        });
      },
      save() {
        this.$apollo.mutate({
          mutation: gql`mutation ($roleId: String!, $userId: String!) {
          grant (roleId: $roleId, userId: $userId) {id user {id name email}}
        }`,
          variables: {
            userId: this.user.id,
            roleId: this.role.id,
          },
        }).then(() => {
          this.$apollo.queries.role.refetch();
        }).catch((error) => {
          this.error = error;
        });
        this.userDialog = false;
        this.user = null;
      },
      addUser() {
        this.$apollo.query({
          query: gql`query {
            users {
              id
              name
              email
            }
        }`,
        }).then(({ data: { users } }) => {
          this.everyUser = users.filter((i) => !this.users.find((j) => j.id === i.id));
          this.userDialog = true;
        }).catch((error) => {
          this.error = error;
        });
      },
    },
  };
</script>


<style lang="stylus" scoped>

</style>
